export const CATEGORY_POPULAR_SLUG = "popular";

